export default __webpack_public_path__ + "assets/images/Star Badge-4386f8a3a241c93c0b03c6575cfdbb33.svg";